"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheV2Synchronized = void 0;
var cache_1 = require("./cache");
Object.defineProperty(exports, "CacheV2Synchronized", { enumerable: true, get: function () { return cache_1.CacheV2Synchronized; } });
//# sourceMappingURL=index.js.map